import React from 'react'
import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'
import { notification } from 'antd'
import RootView from '@framework/root'
import store from '@framework/store'
import { isElectron } from '@/helper'

import './css/index.scss'
import './assets/fonts/iconfont/iconfont.css'

import * as Sentry from "@sentry/react"

// 只在生产环境初始化 Sentry
if (process.env.NODE_ENV === 'prod') {
    Sentry.init({
        dsn: "https://3c94e7075fc3c41a986416ec0f3143e2@sentry.mybaiqiu.com/6",
        // Setting this option to true will send default PII data to Sentry.
        // For example, automatic IP address collection on events
        sendDefaultPii: true,
        integrations: [
            Sentry.browserTracingIntegration(),
            Sentry.replayIntegration()
        ],
        tracesSampleRate: 1.0,
        replaysSessionSampleRate: 0.1,
        replaysOnErrorSampleRate: 1.0,
        release: process.env.SENTRY_RELEASE || process.env.CI_COMMIT_SHA,
        environment: process.env.NODE_ENV
    })
}

// 初始化 RoboLogger（仅在 Electron 环境），在应用启动时赋予一个临时匿名用户，避免早期日志丢失
function bootstrapRoboLogger() {
    try {
        if (typeof isElectron === 'function' && !isElectron()) return
        const rl = window?.RoboLogger
        if (!rl || typeof rl.setUser !== 'function') return
        // 统一匿名标识，避免产生多个匿名日志文件
        rl.setUser('anonymous')
    } catch (e) {
        console.warn('RoboLogger bootstrap failed:', e)
    }
}

notification.config({
    placement: 'topRight',
    closeIcon: null,
    top: 50,
    duration: 2,
    rtl: false
})

// 仅在 Electron 环境提前初始化，避免用户信息未到位时丢日志
bootstrapRoboLogger()

// <React.StrictMode> 会导致开发环境页面渲染两次
createRoot(document.getElementById('root'))
    .render(
        // <React.StrictMode>
        <Provider store={store}>
            <RootView />
        </Provider>
        // </React.StrictMode>,
    )
